import ApiService from "../../services/ApiService";
import ValidationService from "../../services/ValidationService";
import { executeReCaptcha } from "../../helper/executeReCaptcha";
import { exceptionMap } from "../../exceptions/ExceptionMap";

$(document).on('click','.clickable-title',function(){
    $(this).closest('.clickable-cat-left').toggleClass('is-open');
})
$(document).on('click','.open-search, .btn-search-close',function(){
    $('body').toggleClass('search-open');
    //$(".search-input").focus();
    //$(".search-input").focus();

    setTimeout(function(){
        if($('body').hasClass('search-open')){
           $(".search-input").focus();
        }
        
    }, 300);
})
$(document).on('click','.btn-accordion',function(){
    $(this).closest('.tab-pane').toggleClass('active');
})
$(document).on('click','.wish-list-link',function(){
    document.location = $(this).data('href');
})
$(document).on('click','.item-gallery-right-btn',function(){
    MagicZoom.next('item-magiczoom');
})

$(document).on('click','.item-gallery-left-btn',function(){
    MagicZoom.prev('item-magiczoom');
})
$(document).on('click','.item-gallery-expand-btn',function(){
    MagicZoom.expand('item-magiczoom');
})
$(document).on('click','.link-open-mobile-help, .toggle-ddown-help-mobile',function(){
    $('.ddown-help-mobile').toggleClass('is-open');
})



$(document).on('click','.btn-show-more-images',function(){
    $(this).closest('.item-img-gallery').toggleClass('show-more-images');
    if($('.show-more-images').length <= 0){
        //setTimeout(function(){
            var scrollPos = $("#item-magiczoom2").offset().top - $('header').height() - 30;//(+ $(".item-img-gallery").height()) / 2;
            $('html, body').animate({
                scrollTop: scrollPos
             }, 500);
        //}, 400);
    }
    
    
})


$(document).on('change','.fake-attribute-size .custom-select',function(){
    if($(this).val() != 0){
        document.location.href = 'https://www.evenabag.com'+$(this).val();
    }
})


$(document).on('click','.toggle-basket-preview, .toggle-basket-preview-btn',function(){
    $('body').removeClass('open-login');
    
    vueApp.$store.dispatch('loadComponent', 'basket-preview');
    var intervallBasketPrev = setInterval(function () {
        if($('.basket-preview-wrapper').length > 0){
            $('body').toggleClass('basket-open');
            clearInterval(intervallBasketPrev);
        }
    }, 200);
    
})
$(document).on('click','.b2b-login-switch-register',function(){
    $('.b2b-wrap').toggleClass('show-b2b-register');
})
$(document).on('click','.link-right-modal-b2b',function(){
    $($(this).attr('href')).modal('show');
})
$(document).on('click','.show-b2b-register .form-check-label a[href="/datenschutzerklaerung/"]',function(){
    $('#policyrights').modal('show');
    return false;
})


$(document).on('click', 'a[href="#privacy-settings"]', function() {
    $('.cookie-bar').removeClass('out');
    return false;
});

$(document).on('click', ".facet-fake-select", function() {
    $(this).closest('.cat-facet-group').toggleClass('is-open');
    return false;
});
$(document).mouseup(function(e) 
{
    var container = $(".cat-facet-group.is-open");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        //console.log($(container).hasClass('cat-facet'))
        //if(!$(container).hasClass('cat-facet'))
        container.removeClass('is-open');
    }
});

var timeoutHandle;
$(document).on("mouseenter",".mainmenu > .ddown", function () {
    if(window.innerWidth >= 992){
        var _this = this;
        timeoutHandle = setTimeout(function(){ 
             $(_this).addClass('isHover');
             $('body').addClass('menu-hover');
         }, 300); 
    }
    
});
$(document).on("mouseleave",".mainmenu > .ddown", function () {
    if(window.innerWidth >= 992){
        var _this = this;
        clearTimeout(timeoutHandle);
        //setTimeout(function(){ 
            $(_this).removeClass('isHover');
            $('body').removeClass('menu-hover');
        //}, 300);
    }
});
/*
$(document).on("click",".list-prev-images-splide a", function () {
    console.log("dxirnne")
    if($(this).attr('href').indexOf('-1.png') === -1){
        
        $('.item-img-gallery').addClass('full-size-image');
    }else{
        $('.item-img-gallery').removeClass('full-size-image');
    }
});*/



$(document).on("change",".cross-sell-select", function () {
    document.location.href = $(this).find(":checked").val();
});
$(document).on("click",".btn-toggle-filter, .filter-backdrop", function () {
    $('body').toggleClass('open-filter');
});



$(document).on("click",".toggle-login", function () {
    vueApp.$store.dispatch('loadComponent', 'login-modal');
    $('body').toggleClass('open-login');
    $('body').removeClass('basket-open');
});
$(document).on("click",".btn-open-menu", function () {
    $('body').toggleClass('menu-is-visible');
    $('.mobile-navigation').toggleClass('open');
});


document.addEventListener('doofinder.cart.add', function(event) {
    const data = {
        variationId : parseInt(event.detail.item_id),
        quantity    : 1,
        totalOrderParamsMarkup: 0,
        template: 'Ceres::Basket.Basket',
        templateType: 'item'
    };
    vueApp.$store.commit("setIsAddToBasketLoading", data.variationId);
    vueApp.$store.dispatch('loadComponent', 'basket-preview');
    
    vueApp.$store.dispatch("addBasketItem", data).then(
        response =>
        {
            document.dispatchEvent(new CustomEvent("afterBasketItemAdded", { detail: data }));
            vueApp.$store.commit("setIsAddToBasketLoading", 0);
        },
        error =>
        {
            vueApp.$store.commit("setIsAddToBasketLoading", 0);
            if (error.data)
            {
                if(exceptionMap.has(error.data.exceptionCode.toString())){
                    NotificationService.error(
                        vueApp.$translate(
                            "Ceres::Template." + exceptionMap.get(error.data.exceptionCode.toString()),
                            error.data.placeholder
                        )
                    ).closeAfter(5000);
                }else{
                    NotificationService.error(
                        vueApp.$translate("Es ist ein Fehler aufgetreten.")
                    ).closeAfter(5000);
                }

                
            }
        });
});

$(document).on( "submit",".b2b-registration-form", function( event ) {

    

    var form = this;
  event.preventDefault();
  ValidationService.validate($('.b2b-registration-form')[0]).done(() =>
    {
        const deferred = $.Deferred();   
        executeReCaptcha(vueApp.$refs.b2bregistration.$refs.registrationForm)
                .then((recaptchaToken) =>
                {  
       // window.grecaptcha.execute(App.config.global.googleRecaptchaApiKey,
         //   { action: "homepage" }
       // ).then(response =>
        //{
            //if (response)
            //{
                if (!App.config.global.registrationRequirePrivacyPolicyConfirmation || vueApp.$refs.b2bregistration.privacyPolicyAccepted)
                {
                    vueApp.$refs.b2bregistration.privacyPolicyShowError = false;
                    const userObject = vueApp.$refs.b2bregistration.getUserObject();
                    userObject.recaptcha = recaptchaToken;
                    userObject.username = $('.b2b-registration-form [data-testing="mail-register"]').val();
                    
                    const vatData = {
                        vatNumber : userObject.billingAddress.vatNumber
                    }
                    $('.btn-submit-b2b-registration i').attr('class', 'fa default-float fa fa-spin fa-circle-o-notch');
                    registerCustomer(userObject);
                    /*
                    ApiService.get("/rest/vatcheck/", vatData).done(response =>
                    {
                        var dataParsed = JSON.parse(response);

        
                        const newsletterData = {
                            email : userObject.username,
                            firstName: '',
                            lastName: '',
                            emailFolder: 2,
                            templateEvent: 'tpl.home',
                            recaptcha: recaptchaToken,
                            honeypot: ''
                        }
                        
                        if(dataParsed.data.valid){
                            /*if ($('#nlregistration').is(":checked")){
                                ApiService.post("/rest/io/customer/newsletter/", newsletterData)
                                .done(response =>
                                {
                                    registerCustomer(userObject);
                                })
                            }else{
                                
                            }
                            
                        }else{
                            window.CeresNotification.error("Die eingegebene Umsatzsteuer-Identifikationsnummer ist ungültig.").closeAfter(10000);
                            $('.btn-submit-b2b-registration i').attr('class', 'fa default-float fa-user-plus');
                        }       
    
                        
                    })
                    .fail((error) =>
                    {
                        window.CeresNotification.error("Es ist ein Fehler aufgetreten.").closeAfter(10000);
                        //window.CeresNotification.error(error.error).closeAfter(10000);

                    });*/
                }
                else
                {
                    vueApp.$refs.b2bregistration.privacyPolicyShowError = true;
                    window.CeresNotification.error(vueApp.$translate("Ceres::Template.contactAcceptFormPrivacyPolicy", { hyphen: "&shy;" })).closeAfter(10000);
                    window.grecaptcha.reset()
                }
                
            //}
        });
    })
    .fail(invalidFields =>
    {
       //vueApp.$refs.invoiceAddressSelect.$refs.invoice.$refs.updateadress.validate();
       ValidationService.markInvalidFields(invalidFields, "error");
        const fieldNames = [];
        for (const field of invalidFields)
        {
            let fieldName = field.lastElementChild.innerHTML.trim();

            fieldName = fieldName.slice(-1) === "*" ? fieldName.slice(0, fieldName.length - 1) : fieldName;
            fieldNames.push(fieldName);
        }
        window.CeresNotification.error(
            vueApp.$translate("Ceres::Template.checkoutCheckAddressFormFields", { fields: fieldNames.join(", ") })
        );
    });
    return false;
});

function registerCustomer(userObject){
    ApiService.post("/rest/io/customer/", userObject)
    .done(response =>
    {

        ApiService.setToken(response);
        userObject.customerid = response.id;

        if (!response.code)
        {
            document.dispatchEvent(new CustomEvent("onSignUpSuccess", { detail: userObject }));
            $('.btn-submit-b2b-registration i').attr('class', 'fa default-float fa-user-plus');
        }
        else
        {
            window.CeresNotification.error(
                vueApp.$translate("Ceres::Template.regError")
            ).closeAfter(10000);
        }
        window.location.reload();
    })
    .fail((error) =>
    {
        $('.btn-submit-b2b-registration i').attr('class', 'fa default-float fa-user-plus');
        window.CeresNotification.error(error.error).closeAfter(10000);

    });
}

$(document).on('click','.link-gallery-video',function(){
    var videoSrc = $(this).attr('href');
    var videoHtml =  '<video controls>';
    videoHtml += `<source src="${videoSrc}" type="video/mp4">`;
    videoHtml += 'Your browser does not support the video tag.';
    videoHtml += '</video>';
  
    $('.modal-video').find('.modal-body').html(videoHtml);
    $('.modal-video').modal();
    return false;
})
$('.modal-video').on('hidden.bs.modal', function () {
    $('.modal-video').find('.modal-body').html('');
})
if($('.modal-aktion').length>0){
    $(window).scroll(function(){
        if($(window).scrollTop()>800){
            if(getCookie('showModalAktion')==null){
                $('.modal-aktion').modal();
                setCookie('showModalAktion','false',1) 
            }
        }
    });
}

let mainHeading = document.querySelector("h1");

let previousScrollPosition = 0;

const isScrollingDown = () => {
  const scrollPosition = window.pageYOffset;
  const goingDown = scrollPosition > previousScrollPosition;
  previousScrollPosition = scrollPosition;
  return goingDown;
};

const handleScroll = () => {
  const scrollPosition = window.pageYOffset;

  if (scrollPosition <= 0) {
    // Sonderfall: ganz oben
    $('body').removeClass('scroll-down').addClass('scroll-up');
    return;
  }

  if (isScrollingDown()) {
    if ($('.basket-open').length <= 0) {
      $('body').removeClass('scroll-up').addClass('scroll-down');
    }
  } else {
    $('body').removeClass('scroll-down').addClass('scroll-up');
  }
};

document.addEventListener("afterBasketItemAdded", function(variation){
    $('body').removeClass('scroll-down');
})
window.addEventListener("scroll", handleScroll);


$(document).on({
    // 1. Wenn die Maus über eine Box fährt
    mouseenter: function() {
        var hoverValue = $(this).attr('data-attributename');
        $('.selected-attribute-value').text(hoverValue);
    },
    // 2. Wenn die Maus die Box wieder verlässt
    mouseleave: function() {
        // Suche die Box, die die Klasse 'active' hat
        var activeValue = $('.v-s-box.active').attr('data-attributename');
        
        // Falls eine aktive Box existiert, setze den Text zurück
        if (activeValue) {
            $('.selected-attribute-value').text(activeValue);
        }
    }
}, '.v-s-box'); // Der Selektor für die Live-Elemente